import { Component } from "@angular/core";

@Component({
  selector: "app-page-not-found",
  template: `
    <app-entity-not-found
      resource="page"
      hintSuffix=""
      backTo="/services"
      backLabel="Back to services">
    </app-entity-not-found>
  `,
})
export class PageNotFoundComponent {}
